import { render, staticRenderFns } from "./PayrollReports.vue?vue&type=template&id=dd65f2a0&scoped=true"
import script from "./PayrollReports.vue?vue&type=script&lang=js"
export * from "./PayrollReports.vue?vue&type=script&lang=js"
import style0 from "./PayrollReports.vue?vue&type=style&index=0&id=dd65f2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd65f2a0",
  null
  
)

export default component.exports